import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { State } from 'widgets/friends-referral/root/root.reducers';
import Content from './content.component';
import { logOut, requestLoginSession } from '../../../../modules/login/login.actions';
import { WEBSITE_MODE } from '@sitegen/common/constants';

const mapStateToProps = (state: State) => ({
    showGameLogo: state.config.friendsReferral?.showGameLogo ?? false,
    mode: state.config.mode
});

const mapDispatchToProps = {
    logOut,
    requestLoginSession
};

export type IContentProps = {
    readonly children: ReactNode,
    readonly showGameLogo?: boolean,
    readonly requestLoginSession: () => void,
    readonly logOut: () => void,
    readonly shouldInheritStyles: boolean,
    readonly mode: WEBSITE_MODE
};

export default connect(mapStateToProps, mapDispatchToProps)(Content);
